import axios from 'axios';
import events from 'shared/settings/events';
import { initGlobalAxiosSettings } from './initGlobalAxiosSettings'

const axiosInstance = axios.create();
initGlobalAxiosSettings(axiosInstance);
initGenericErrorHandlerHCP(axiosInstance);

function fireEvent(error) {
    let event = new CustomEvent(events.API_ERROR, {detail: error.response.data });
    document.dispatchEvent(event);
}

function fireLoginExpiredEvent() {
    let event = new CustomEvent(events.API_EXPIRED_SESSION_ERROR, {detail: "ERROR" });
    document.dispatchEvent(event);
}

export function initGenericErrorHandlerHCP(instance) {
	instance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
		if (error.response?.status == 401) {
			if (document.querySelector('#login-expired-modal')) {
				fireLoginExpiredEvent();
			} else {
				window.loggedOut = true;
				window.location.assign(error.response.data.loginUrl);
			}
        }
        else if (!axios.isCancel(error)) {
            fireEvent(error);
        }
        return Promise.reject(error);
    });
}

export default axiosInstance;
